export const DASHBOARD ="dashBoard/dashboard"
export const EDITSHIPMENT ="dashBoard/dashboard?edit"
export const ARCHIVEGRID ="dashBoard/dashboard?archive"
export const TRASHGRID ="dashBoard/dashboard?trash"
export const ARCHIVE_ROW_IDS ="dashBoard/dashboard?archiveIds"
export const TRASH_ROW_IDS ="dashBoard/dashboard?trashIds"
export const HANDLER_ADDRESS="ShipmentPlan/formApis?handlerAddress"
export const AIRLINECONCERNED="ShipmentPlan/formApis?airlineConcerned"
export const CUSTOMCODE="ShipmentPlan/formApis?customCode"
export const SPECIALHANDLINGCODE="ShipmentPlan/formApis?specialHandlingcode"
export const SECURITYCODE="ShipmentPlan/formApis?securityCode" 
export const SUBMIT_SHIPMENT_FORM="ShipmentPlan/formSubmit"
export const GRID_DATETIME_UPDATE="ShipmentPlan/editShipment?dateTimeUpdate"
export const BOOKINGSLOTS="ShipmentPlan/formApis?availableTimingSlot"
export const ULDTYPECODES ="ShipmentPlan/formApis?getTypeCodes"
export const ULDOWNERCODES ="ShipmentPlan/formApis?getOwnerCode"
export const USERSTATIONS ="users/usersInfo?orgStations"
export const USERLISTS ="users/usersInfo?userList"
export const SUBMITLIST ="users/usersInfo?saveUser"
export const USERDETAILS ="users/usersInfo?userDetails"
export const USERDELETE ="users/usersInfo?deleteUser"

export const STATIONS ="get-all-stations"
export const ADDSTATION ="add-trucker-station"
export const STATIONGRID ="get-trucker-stations"
export const ADDTRUCKER ="trucker-save"
export const TRUCKERGRID ="trucker-list"
export const TRUCKERACTIVE ="trucker-active"
export const TRUCKERARCHIVE ="trucker-archive"
export const TRUCKERTRASH ="trucker-trash"
export const TRUCKERADDEMAIL ="trucker-save-email"
export const TRUCKEREDITEMAIL ="trucker-save-email"
export const TRUCKERDELEMAIL ="trucker-delete-email"
export const TRUCKERSAVERATE ="trucker-save-rate"
export const TRUCKERRATELIST ="trucker-rates-list"
export const TRUCKORDERDETAILS ="truck-order-details"
export const TRUCKORDERLIST ="truck-order-list"

export const ACTSTATIONGRID ="active-station"
export const ARCSTATIONGRID ="archive-station"
export const REMSTATIONGRID ="delete-station"
export const ADDSTATIONADDRESS ="add-station-address"
export const ADDTRUCKSCHEDULE ="add-truck-schedule"
export const BOOKINGTRUCKGRID ="booking-truck"
export const BOOKINGTRUCKMOVE ="truck-schedule-move-to-trash"
export const BOOKINGTRUCKDETAILS ="get-booking-truck-schedule"
export const SAVEATTACHMENTS ="attachment-save"
export const HISTORYSAVEATTACHMENTS ="uld-history/attachment-save"

export const GETTYPECODE ="uld-forms/get-type-code"
export const GETDESTINATION ="uld-forms/get-destinations"
export const GETAGENT ="uld-forms/get-agents"
export const GETINTAGENT ="uld-forms/get-internal-agents"
export const GETEXTAGENT ="uld-forms/get-external-agents"
export const GETINTAGENTHAND ="uld-forms/get-internal-handler-agents"
export const GETOWNERCODE ="uld-forms/get-owner-code"
export const GETCONTENTCODE ="uld-forms/get-content-code"
export const GETCONDITIONCODE ="uld-forms/get-condition-code"
export const GETDAMAGETYPE ="uld-forms/damage-type"
export const UPDATESTATUS ="uld-action/update-uld-status"
export const UPDATECONDITION ="uld-action/condition-change"
export const IMPORTEXCEL ="uld-forms/import-uld-excel"
export const SAVEULDSTOCK ="save-uld-stock"
export const EDITULDSTOCK ="edit-uld"
export const EDITONAIR ="uld-action/on-air-edit"
export const ULDASSETSGRID ="uld-control/assets"
export const MOVETOACTARC ="uld-action/move-active-archive"
export const ULDSEARCH ="search-uld"
export const ULDSEARCHDETAILS ="get-uld-details"
export const GETULDDETAILS ="get-uld-details"
export const ULDOPERATIONGRID ="uld-control/operations"
export const ULDONAIRGRID ="uld-control/onair"
export const ULDREPAIRGRID ="uld-control/repair"
export const ULDONLOANGRID ="uld-control/onloan"
export const ULDTRANSFERGRID ="uld-control/agents-overview"
export const ULDREPAIRUPDATE ="uld-action/moveTo-repair"
export const ULDALLUPDATE ="uld-action/update-mvt"
export const STTRUPDATE ="uld-action/save-station-transfer"
export const MSGPROCESSCHARTER ="uld-forms/ffm-message-processing"
export const MSGPROCESSMVT ="uld-forms/message-processing"
export const ULDEXIST ="is-exists-uld"
export const SAVEULDCHARTER ="save-uld-charter"
export const DOWNLOADULD ="download-ulds"
export const DOWNLOADULDRFS ="download-booking-truck-schedule"
export const CALENDER ="date-booking-schedule"
export const OTCALENDER ="date-operational-truck"
export const DOWNLOADFILES ="attachment-download"
export const MSGGRID ="messages/list"
// export const CONVERTBLOB ="get-file-blob"
export const MVTUPDATE ="uld-action/mvt-update-logic"
export const FINALIZETR ="uld-action/finalize-pending-transfer"
export const MVTONLOAN ="uld-action/transfer-logic"
export const MVTHDETAILS ="uld-history/movement-history-details"
export const EDITPTRANSFER ="uld-action/edit-pending-transfer"

export const UCMHISTORYGRID ="uld-history/get-movement-history"

export const ULDSETTINGSTATION ="uld-settings/stations"
export const ULDSTATIONDETAILS ="uld-settings/station-address"
export const ULDADDRESSSAVE ="uld-settings/save-address"
export const ULDADDRESSACTARC ="uld-settings/move-active-archive"
export const ULDADDRESSRECMAIL ="uld-settings/save-recovery-email"
export const ULDSETRECOVERY ="recovery/resend-mail"
export const ULDRECOVERYDETAIL ="recovery/details"
export const RECOVERYNOTESAVE ="recovery/case-note-save"
export const OTRUCKSAVE ="planning-operational-truck-save"
export const OTRUCKDETAIL ="truck-order-details"
export const OTRUCKREMOVE ="planning-operational-truck-remove"
export const OTRUCKASSIGN ="awb-planning/pallet-group-assign-truck"
export const DELETERECEMAIL ="uld-settings/remove-recovery-email"
export const ULDBACK ="login"
export const ULDEXISTS ="is-exists-uld"
export const FILTERRECEIVEDBY ="filter-onloan-received-by"
export const RECMISSING ="recovery/uld-move-to-missing"
export const MISSINGSTATION ="get-stations"
export const GETMISSINGDATA ="get-encrypted-information"
export const UPDATEMISSING ="missing-uld-update"
export const UPDATERECOVERY ="recovery/uld-found"
export const MSGSETTINGLIST ="setting/rules-list"
export const SAVEMSGRULE ="setting/rules-add"
export const SWITCHMSGRULE ="setting/activity-status-update"
export const DELETERULE ="setting/rules-delete"

export const CHARTULD ="chart/uld-count"
export const CHARTTABLE ="chart/uld-matrix"
export const CHARTOWNERTABLE ="chart/uld-matrix-station-owner-code"
export const CHARTCOND ="chart/uld-condition-code"
export const CHARTYPE ="chart/uld-type-code"
export const CHARTOWNER ="chart/uld-owner-code"
export const CHARTSTATION ="chart/uld-station"
export const CHARTSTATUS ="chart/uld-status"
export const CHARTTYPECOND ="chart/uld-type-condition-code"
export const CHARTSTNCOND ="chart/uld-station-condition-code"
export const CHARTLOANAGENTS ="chart/onloan-agents"


export const DELETEATTACHMENTS ="attachment-delete"
export const COMMENTSAVE ="comment-submit"
export const TRUCKORDERSAVE ="truck-order-save"
export const GETSCHEDULEDTRUCKS ="get-scheduled-trucks"
export const AWBADD ="awb/store-update"
export const GETSHC ="special-handling-code"
export const AWBGRID ="awb/list"
export const AWBGRIDDETAILS ="awb/details"
export const ADDAWB ="awb-action-management"
export const DELAWB ="awb-remove"
export const AWBMSG ="awb/message-processing"
export const PALLETLIST ="awb-planning/pallet-group-list"
export const ADDPALLET ="awb-planning/pallet-group-add"
export const ASSIGNPALLET ="awb-planning/pallet-group-assign"
export const REMOVEPALLET ="awb-planning/pallet-group-delete"
export const TRUCKPLANNINGLIST ="planning-operational-truck-list"
export const AWBGETBTN ="get-scheduled-trucks"
export const COMMENTDELETE ="comment-delete"
export const COMMENTEDIT ="comment-edit"
export const IMAGETOBASE64 ="uld-action/convert-imageToBase64?url="
export const TRUCKORDERSDETAILS ="monitor/order-details"
export const TRUCKAWBDETAILS ="monitor/awb-details"
export const TRUCKERSEARCH ="monitor/search-list"
export const MONITORDOWNLOAD ="monitor/download-rfs"
export const MONITORLOADINGSTATION ="monitor/get-loading-stations"
export const MONITORUNLOADINGSTATION ="monitor/get-unloading-stations"
export const MONITORTRUCKERS="monitor/get-truckers"
export const MONITORCARRIERS ="monitor/get-carriers"


export const AIRLINEUSER ="airline/user-list"
export const AIRLINESTATION ="airline/station-list"
export const AIRLINESTATIONADD ="airline/station-add"
export const AIRLINEADDUSER ="airline/user-create"
export const AIRLINESAVEUSER ="airline/user-save"
export const AIRLINEREMOVEUSER ="airline/user-remove"
export const AIRLINEACTARC ="airline/station-active-archive"


export const SAVERECOVERY ="service-recovery/save"
export const STATIONLIST ="station-handler-list"
export const STATIONHANDLER ="get-handlers"
export const SAVEHANDLER ="handler-contacts/save"
export const RECOVERYDETAILS ="service-recovery/details"
export const HANDLERRDETAILS ="handler-feedback/details"
export const RECOVERYARCACT ="service-recovery/move-archive"
export const SAVECONVO ="conversation/save"
export const SROPENCLOSE ="service-recovery/make-close-or-open"
export const HANDLERUPDATE ="handler-feedback/update"
export const MSGSTATUSUPDATE ="conversation/status-update"
export const CHARTASR ="chart/service-recovery"


export const SLOTPLANNINGMETADATA ="tracking-metatypes"
export const SLOTPLANNINGWAREHOUSE ="warehouse/list"

export const SLOTPLANNINGWAREHOUSEADDEDIT ="warehouse/add-update"
export const SLOTPLANNINGWAREHOUSEACTIVEDEACTIVE ="warehouse/warehouse-status"
export const SLOTPLANNINGWAREHOUSEDELETERESTORE ="warehouse/delete-restore"

export const SLOTPLANNINGDOORSAVE ="door/save"
export const SLOTPLANNINGDOORUPDATE ="door/door-status"
export const SLOTPLANNINGDOORDELETERESTORE ="door/delete-restore"
export const SLOTPLANNINGSAVESLOTSETTINGS ="door-settings/save-slot-settings"
export const SLOTPLANNINGRESOURCEADDUPDATE ="warehouse-resource/add-update"
export const SLOTPLANNINGRESOURCELIST ="warehouse-resource/list"
export const SLOTPLANNINGRESOURCEDELETE ="warehouse-resource/delete-restore"

export const SLOTPLANNINGPLANNINGDASHBOARD ="planning-dashboard"
export const SLOTPLANNINGAVAILABLESLOT ="door/available-slot"
export const SLOTPLANNINGAVAILABLESLOTCOUNT ="date/available-slot"
export const SLOTPLANNINGSETDOORCONFIGURATION ="door-settings/set-door-configuration"
export const SLOTDETAILS ="slot-details"
export const ORGANIZATIONSTATIONADDEDIT ="organization-station/add-edit"
export const ORGANIZATIONSTATIONDELETERESTORE ="organization-station/delete-restore"
export const ORGANIZATIONSTATIONSTATIONLIST ="organization-station/list"
export const SHIPMENTSAVEINVOICECATEGORY ="shipment/save-invoice-category"
export const SHIPMENTINVOICECATEGORIESSELECT ="shipment/invoice-categories-select"
export const ADDRESSBOOKDROPDOWN ="address-book/dropdown"



export const RULESADDUPDATE ="rules/add-update"
export const RULESDELETERESTORE ="rules/delete-restore"


